import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { i18n as i18nModule } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
  forActivation: {
    type: Boolean,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  mode: {
    type: String,
    required: true,
  },
},
  emits: ['closeDialog', 'openDialog'],
  setup(__props, { emit: emits }) {

const props = __props;

const $t = i18nModule.t.bind(i18nModule);

const m = defineMessages({
  enable: '有効にする',
  disable: '無効にする',
  reloginRequired: '再度ログインする必要があります',
  dialogActivationMessage: '二要素認証を設定し、{loginInfo}',
  dialogDeactivateTfa:
    '二要素認証を無効にすると、アカウントのセキュリティが低下します。本当に無効にしますか？',
  dialogDeactivateSmsAuth:
    'SMS認証を無効にすると、アカウントのセキュリティが低下します。本当に無効にしますか？',
  dialogDeactivateTotpAuth:
    'アプリ認証を無効にすると、アカウントのセキュリティが低下します。本当に無効にしますか？',
  disableSmsAuth: 'SMS認証を無効にする',
  disableTotpAuth: 'アプリ認証を無効にする',
  enableEmailAuth: 'メール認証を有効にする',
  disableEmailAuth: 'メール認証を無効にする',
  dialogDeactivateEmailAuth:
    'メール認証を無効にすると、アカウントのセキュリティが低下します。本当に無効にしますか？',
});



const titleKey = ref('');
const messageKey = ref('');

watch(
  () => props.isOpen,
  (isOpen) => {
    if (!isOpen) return;

    if (props.mode === 'phone_code') {
      titleKey.value = props.forActivation
        ? sharedMessages.enableSmsAuth
        : m.disableSmsAuth;

      if (props.forActivation) {
        messageKey.value = m.dialogActivationMessage;
      } else {
        messageKey.value = props.forActivation
          ? m.dialogDeactivateTfa
          : m.dialogDeactivateSmsAuth;
      }
    } else if (props.mode === 'totp') {
      titleKey.value = props.forActivation
        ? sharedMessages.enableTotpAuth
        : m.disableTotpAuth;

      if (props.forActivation) {
        messageKey.value = m.dialogActivationMessage;
      } else {
        messageKey.value = props.forActivation
          ? m.dialogDeactivateTfa
          : m.dialogDeactivateTotpAuth;
      }
    } else if (props.mode === 'email') {
      titleKey.value = props.forActivation
        ? m.enableEmailAuth
        : m.disableEmailAuth;

      messageKey.value = props.forActivation
        ? m.dialogActivationMessage
        : m.dialogDeactivateEmailAuth;
    }
  },
  { immediate: true }
);



const handleCloseAction = () => {
  emits('closeDialog');
};

const handleOpenAction = () => {
  emits('openDialog');
};

const visible = computed(() => props.isOpen);

return { __sfc: true,$t, m, props, titleKey, messageKey, emits, handleCloseAction, handleOpenAction, visible, sharedMessages }
}

})